import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxXml2jsonService } from 'ngx-xml2json';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { MD5UtilService } from '../services/MD5Util.service';
@Injectable({
  providedIn: 'root'
})
export class AepsService {
  private currentdeviceInfoSubject: BehaviorSubject<any>;
  private captureDeviceInfoSubject: BehaviorSubject<any>;
 
  obj: any;
  captureDeviceInfoObj: any;
  captureDeviceInfoObjInXML = new BehaviorSubject('');

  deviceCaptureInfo: any;
  public deviceInfoRes: Observable<any>;
  public captureRes: Observable<any>;

  constructor(private ngxXml2jsonService: NgxXml2jsonService, private http: HttpClient,private md5Util:MD5UtilService) {
    this.currentdeviceInfoSubject = new BehaviorSubject<any>(this.obj);
    this.captureDeviceInfoSubject = new BehaviorSubject<any>(this.captureDeviceInfoObj);
   
    this.deviceInfoRes = this.currentdeviceInfoSubject.asObservable();
    this.captureRes = this.captureDeviceInfoSubject.asObservable();
  }
  public get currentUserValue(): any {
    return this.currentdeviceInfoSubject.value;
  } 
  deviceInfoAvdm(device) {            
    const xhr = new XMLHttpRequest();
    let deviceValue = device        
    let  url ='https://127.0.0.1:11100/rd/info';
    if (deviceValue==1) {
      url="https://127.0.0.1:11100/getDeviceInfo";
    }
    if (deviceValue==6) {
      url="https://127.0.0.1:8005/rd/info";
    } 
    xhr.open('DEVICEINFO', url);
    // create a JSON object
    // const params = '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="' + 5 + '" fType="' + "FMR" + '" iCount="' + 1 + '" pCount="' + 1 + '" format="' + 0 + '"   pidVer="' + 2.0 + '" timeout="' + 60000 + '" posh="UNKNOWN" env="' + 'P' + '" /> ' + 'this.DemoFinalString' + '<CustOpts><Param name="mantrakey" value="' + '' + '" /></CustOpts> </PidOptions>';
    // set `Content-Type` header
    xhr.setRequestHeader('Content-Type', 'text/xml');

    // pass `params` to `send()` method
    xhr.send();

    // listen for `load` event
    xhr.onload = () => {
      const parser = new DOMParser();
      const xml = parser.parseFromString(xhr.responseText, 'text/xml');
      this.obj = this.ngxXml2jsonService.xmlToJson(xml);
      this.currentdeviceInfoSubject.next(this.obj);
    };
    xhr.onerror = function (e) {
      console.log('eoor', e);
      if (e.type == 'error') {
        alert('please download the Driver');
        let deviceUrl = ''
            switch (deviceValue) {
              case 6:
                deviceUrl = 'https://download.mantratecapp.com/Forms/DownLoadFiles';
                break;
            
              case 3:
                deviceUrl = 'https://mpvanmitra.mkcl.org/hi/faqs/user-guide/Startek_FM220_Biometric_Installation_Guide.pdf';
                break;
            
              case 8:
                deviceUrl = 'https://drive.google.com/file/d/1lKJKedZRu2yJ3lDgxDdW_8nA7V9VQjz1/view';
                break;
            
              case 1:
                deviceUrl = 'https://rdserviceonline.com';
                break;
            
              default:
                break;
            }
            window.open(deviceUrl, 'blank');
      }

    };

  }

  deviceCapture(device) { 
    console.log("aepsservice87::",device);   
    let deviceValue = device.value.device
    let  captureUrl = 'https://127.0.0.1:11100/';       
    if (deviceValue==3 || deviceValue==8 || deviceValue==4|| deviceValue==5) {
        captureUrl+='rd/capture';
    }else if(deviceValue==1){
      captureUrl='https://127.0.0.1:11100/rd/capture';
    }else if (deviceValue==6) {
      captureUrl="https://127.0.0.1:11100/rd/capture";
    }
    
    const xhr = new XMLHttpRequest();
    xhr.open('CAPTURE',captureUrl);
    
    const reqParam = '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0"   pidVer="2.0" timeout="10000" wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" posh="UNKNOWN" env="P" /> <CustOpts><Param name="mantrakey" value="undefined" /></CustOpts> </PidOptions>';
    xhr.setRequestHeader('Content-Type', 'text/xml');

    // pass `params` to `send()` method
    xhr.send(reqParam);

    // listen for `load` event
    xhr.onload = async () => {
      const parser = new DOMParser();
      const xml = parser.parseFromString(xhr.responseText, 'text/xml');

      this.setcaptureDeviceInfoObjInXML(xml);
      // const data = xml.toString()
      // console.log("geeetttaaxml:::::::::::::;", data)
      // this.captureDeviceInfoObj = this.ngxXml2jsonService.xmlToJson(xml);
      this.captureDeviceInfoObj = await this.xmlToJsonfn(xml);
      console.log('this.captureDeviceInfoObj:::', this.captureDeviceInfoObj);
      if (this.captureDeviceInfoObj.PidData) {
        this.captureDeviceInfoSubject.next(this.captureDeviceInfoObj);
      }
      // return xhr.responseText;
    };
  } 
  setcaptureDeviceInfoObjInXML(xml){
    this.captureDeviceInfoObjInXML.next(xml);
    }
    getcaptureDeviceInfoObjInXML(){
      return this.captureDeviceInfoObjInXML.asObservable();
    }
 
  // Changes XML to JSON
  xmlToJsonfn(xml) {
    // var data = xml.toString()
    // const data = new XMLSerializer().serializeToString(xml.documentElement);
    // console.log("here:::::::::::::",data)
      
    // Create the return object
    var obj = {};

    if (xml.nodeType == 1) { // element
      // do attributes
      if (xml.attributes.length > 0) {
        obj["@attributes"] = {};
        for (var j = 0; j < xml.attributes.length; j++) {
          var attribute = xml.attributes.item(j);
          obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
        }
      }
    } else if (xml.nodeType == 3) { // text
      obj = xml.nodeValue;
    }

    // do children
    if (xml.hasChildNodes()) {
      for (var i = 0; i < xml.childNodes.length; i++) {
        var item = xml.childNodes.item(i);
        var nodeName = item.nodeName;
        if (typeof (obj[nodeName]) == "undefined") {
          obj[nodeName] = this.xmlToJsonfn(item);
        } else {
          if (typeof (obj[nodeName].push) == "undefined") {
            var old = obj[nodeName];
            obj[nodeName] = [];
            obj[nodeName].push(old);
          }
          obj[nodeName].push(this.xmlToJsonfn(item));
        }
      }
    }
    return obj;
  };

  getBankList() {
     let headers = new HttpHeaders();
  headers = headers.append('apikey', environment.api_key);
    return this.http.get(`${environment.walletUrl}/ym/admin/get/aepsbank`,{headers:headers});
    // return this.http.get("https://fingpayap.tapits.in/fpaepsservice/api/bankdata/bank/details");

  }
  getBankListAP() {
    let headers = new HttpHeaders();
  headers = headers.append('apikey', environment.api_key);
    
    return this.http.get(`${environment.walletUrl}/ym/admin/get/aadharbank`,{headers:headers});

    // return this.http.get("https://fingpayap.tapits.in/fpaepsservice/api/bankdata/bank/aadharpay");

  }
  
  
  agentCheckBankBalance(params,dsn,checksum) {   
    var md5key=localStorage.getItem('md5key');
    console.log("md5key:::::::::",md5key,'checksum+md5key==>',checksum+md5key);
    var md5Checksum = this.md5Util.getMd5Checksum(checksum+md5key);
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
    var token = localStorage.getItem('wallet-token');
    console.log('token', token);
      let headers = new HttpHeaders();
      headers = headers.append('authToken', token);
      headers = headers.append('deviceSerialNumber', dsn);
      headers = headers.append('checkSum', md5Checksum.toString());
      headers = headers.append('apikey', environment.api_key);
   
      return this.http.post(`${environment.baseUrl}/v1/ym/retailor/aeps/bankbalance`, params, { headers: headers });
    
      
  }
  yesBankCheckBankBalance(params,dsn) {   
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
    var token = localStorage.getItem('wallet-token');
    console.log('token', token);
      let headers = new HttpHeaders();
      headers = headers.append('authToken', token);
      headers = headers.append('deviceSerialNumber', dsn);
      headers = headers.append('apikey', environment.api_key);
      return this.http.post(`${environment.baseUrl}/v1/ym/retailor/yesbank/aeps/service`, params, { headers: headers });
    
      
  }
  cashWithdrawal(params,dsn,checksum) {
    var md5key=localStorage.getItem('md5key');
    console.log("md5key:::::::::",md5key,'checksum+md5key==>',checksum+md5key);
    var md5Checksum = this.md5Util.getMd5Checksum(checksum+md5key);
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
    var token = localStorage.getItem('wallet-token');
    
      console.log('token', token);
      let headers = new HttpHeaders();
      headers = headers.append('authToken', token);
      headers = headers.append('deviceSerialNumber', dsn);
      headers = headers.append('checkSum', md5Checksum.toString());
      headers = headers.append('apikey', environment.api_key);
   
   
      return this.http.post(`${environment.baseUrl}/v1/ym/retailor/aeps/cashwithdrwal`, params, { headers: headers });

    

  }
  ministatement(params,dsn,checksum){
    var md5key=localStorage.getItem('md5key');
    console.log("md5key:::::::::",md5key,'checksum+md5key==>',checksum+md5key);
    var md5Checksum = this.md5Util.getMd5Checksum(checksum+md5key);
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
    var token = localStorage.getItem('wallet-token');
      console.log('token', token);
      let headers = new HttpHeaders();
      headers = headers.append('authToken', token);
      headers = headers.append('deviceSerialNumber', dsn);
      headers = headers.append('checkSum', md5Checksum.toString());
      headers = headers.append('apikey', environment.api_key);
   
     return this.http.post(`${environment.baseUrl}/v1/ym/retailor/aeps/ministatement`, params, { headers: headers });

    
  }

  cashWithdrawalAP(params,dsn,checksum) {
    var md5key=localStorage.getItem('md5key');
    console.log("md5key:::::::::",md5key,'checksum+md5key==>',checksum+md5key);
    var md5Checksum = this.md5Util.getMd5Checksum(checksum+md5key);
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
    var token = localStorage.getItem('wallet-token');
    
      console.log('token', token);
      let headers = new HttpHeaders();
      headers = headers.append('authToken', token);
      headers = headers.append('deviceSerialNumber', dsn);
      headers = headers.append('checkSum', md5Checksum.toString());
      headers = headers.append('apikey', environment.api_key);
   
      return this.http.post(`${environment.baseUrl}/v1/ym/admin/aadharpay/cashwithdrwal`, params, { headers: headers });

    

  }
  bankstates() {
    //`${environment.baseUrl}/v1.0/api/get/all/state/aeps`
    return this.http.get('../../assets/banklist.json');
  }
  emailVerify(email) {
    return this.http.get(`${environment.allienceBaseUrl}/v1/user/emailVerification/${email}`)
  }
  verifyVeriEmailOtp(emailOtp){
    return this.http.get(`${environment.allienceBaseUrl}/v1/user/emailVerificationOTP/${emailOtp}`)
  }
getAepsBankSuccessRatio(transactionType,bankIIN,aepsProvider,date){
  // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
  var token = localStorage.getItem('wallet-token');
  let headers = new HttpHeaders();
  headers = headers.append("authToken",token);
  return this.http.get(`${environment.walletUrl}/ym/retailor/aeps/success/ration?transactionType=${transactionType}&bankIIN=${bankIIN}&aepsProvider=${aepsProvider}&date=${date}`,{ headers: headers })

}
  
}
